class BaseStorage {
  name: string;
  instance: Storage;

  constructor(name: string) {
    this.name = name;
    this.instance = window.localStorage;
  }

  buildKey(key: string) {
    return `@${this.name}-${key}`;
  }

  setValue(key: string, value: any) {
    const customKey = this.buildKey(key);
    this.instance.setItem(customKey, JSON.stringify(value));
  }

  getValue(key: string) {
    const customKey = this.buildKey(key);
    const value = this.instance.getItem(customKey);

    try {
      return JSON.parse(value || "");
    } catch {
      return value;
    }
  }

  setlistValue = (lists: any) => {
    lists.map((list: any) => {
      this.setValue(list.key, list.value);
      return true;
    });
  };

  deleteKey = (key: any) => {
    localStorage.removeItem(this.buildKey(key));
  };

  clear() {
    const arr = [] as any; // Array to hold the keys
    // Iterate over localStorage and insert the keys that meet the condition into arr
    for (let i = 0; i < localStorage.length; i += 1) {
      if (localStorage.key(i)?.startsWith(this.buildKey(""))) {
        arr.push(localStorage.key(i));
      }
    }

    // Iterate over arr and remove the items by key
    // eslint-disable-next-line no-restricted-syntax
    for (const element of arr) {
      localStorage.removeItem(element);
    }
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (name: string) => new BaseStorage(name);
